// extracted by mini-css-extract-plugin
export default {"filterBox":"ZoominfoEmployee_filterBox__wZDlK","icon":"ZoominfoEmployee_icon__hqHY4"};